export class SalesAgentTotalBookings {

    constructor(
        public salesAgentName: string,
        public totalThisYear: number,
        public totalLastYear: number,
        public totalTwoYearsAgo: number
    ){}
}
